import styled from "styled-components";

export default styled.div`
    flex-direction: column;
    display: flex;
    max-height: calc(100vh - 40px);
    overflow: hidden;

    .tabs {
        min-height: 0;
        max-height: 100%;
        overflow: hidden;

        .tabsBar {
            flex-shrink: 0;
        }

        .tabsContent {
            display: flex;
            flex-direction: column;
            min-height: 0;
            max-height: 100%;
            overflow: hidden;
        }
    }
`;
